<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Create Request</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericNew v-if="generic" ref="loadGeneric" :urls="urls"></GenericNew>
        <CustomNew v-else></CustomNew>  
    </main> 
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/EdRequests/MenuList.vue";
    import lang from "@/views/modules/EdRequests/language/en";
    import GenericNew from "@/components/layout/shared/generic/NewView.vue";
    import CustomNew from "@/views/modules/EdRequests/NewView.vue";

    export default {
        name: "new-ed-request",
        components: {
            breadcrumbs,
            GenericNew,
            CustomNew,
        },
        data() {
            return {
                generic: false,
                metaList: [
                    {
                        type: 'selectcomponent',
                        name: 'user_name',
                        label: lang.LBL_PI_NAME,
                        required: false,
                        linkComponent: 'user',
                        moduleName: 'Users',
                        parent_id: 'assigned_user_id',
                        parent_type: 'user_name',
                    },
                    {
                        type: 'text',
                        name: 'parent_type',
                        label: lang.LBL_PARENT_TYPE,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'parent_id',
                        label: lang.LBL_PARENT_ID,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'mobile',
                        label: lang.LBL_PI_MOBILE,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'professional',
                        label: lang.LBL_PI_PROFESSIONAL,
                        required: true
                    },
                    {
                        type: 'textarea',
                        name: 'description',
                        label: lang.LBL_DESCRIPTION,
                        required: true
                    },
                ],
                urls: 'api/modules/edrequests',

                routePath: {
                    path: 'edrequests',
                    detail: false
                }
            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>